window.materialRipple = element => {
  element.addEventListener('click', e => {
    let targetEl = element
    let inkEl = targetEl.querySelector('.ripple-ink')
    let inkDarkEl = targetEl.querySelector('.ripple-ink-dark')

    if (inkEl) {
      inkEl.classList.remove('animate-ripple')

      inkEl.style.left = (e.offsetX - inkEl.offsetWidth / 2) + 'px'
      inkEl.style.top = (e.offsetY - inkEl.offsetHeight / 2) + 'px'
      inkEl.classList.add('animate-ripple')

      return
    }

    if (inkDarkEl) {
      inkDarkEl.classList.remove('animate-ripple')

      inkDarkEl.style.left = (e.offsetX - inkDarkEl.offsetWidth / 2) + 'px'
      inkDarkEl.style.top = (e.offsetY - inkDarkEl.offsetHeight / 2) + 'px'
      inkDarkEl.classList.add('animate-ripple')

      return
    }

    if (!inkEl && !inkDarkEl) {
      inkEl = document.createElement('span')

      if (element.classList.contains('js-ripple-dark')) {
        inkEl.classList.add('ripple-ink-dark')
      } else {
        inkEl.classList.add('ripple-ink')
      }

      inkEl.style.width = inkEl.style.height = Math.max(targetEl.offsetWidth, targetEl.offsetHeight) + 'px'
      targetEl.appendChild(inkEl)

      inkEl.style.left = (e.offsetX - inkEl.offsetWidth / 2) + 'px'
      inkEl.style.top = (e.offsetY - inkEl.offsetHeight / 2) + 'px'
      inkEl.classList.add('animate-ripple')
    }
  }, false)
}

const rippleLinks = document.querySelectorAll('.js-ripple')

for (let i = 0; i < rippleLinks.length; i++) {
  window.materialRipple(rippleLinks[i])
}
